import React from 'react';
import { css, cx } from 'linaria';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { theme } from '../../Theme';
import { buttonBaseCSS, buttonSecondary } from '../../ui/Button';

const navigationItemsCSS = css`
  display: flex;
  flex-direction: column;
  padding-bottom: ${theme.space[2]};
  margin-bottom: ${theme.space[1]};

  ${theme.above.md} {
    flex-direction: row;
  }

  a {
    text-decoration: none;
  }

  &__item {
    display: inline-flex;
    font-weight: normal;
    width: 100%;

    &.active {
      background: ${theme.colors.grey200};
    }
  }

  ${theme.above.md} {
    grid-gap: ${theme.space[2]};
  }
`;

const base = navigationItemsCSS;

export const SubcategoryBlock = ({
  id,
  name,
  primaryRoute,
  activeCategoryId
}) => {
  return !primaryRoute ? null : (
    <CategoryLink
      className={cx(
        `${base}__item`,
        id === activeCategoryId ? `${base}__item--active` : null,
        buttonBaseCSS,
        buttonSecondary
      )}
      category={{ primaryRoute }}
    >
      {name}
    </CategoryLink>
  );
};

const NavigationItems = ({ categories, categoryId }) => {
  return categories?.length > 0 ? (
    <ul className={cx('navigation-items', base)}>
      {categories.map(cat => (
        <li
          className={cx('navigation-list-item', `${base}__list-item`)}
          key={cat.id}
        >
          <SubcategoryBlock
            id={cat.id}
            name={cat.name}
            primaryRoute={cat.primaryRoute}
            activeCategoryId={categoryId}
          />
        </li>
      ))}
    </ul>
  ) : null;
};

export default NavigationItems;
